module.exports = __webpack_public_path__ + "static/media/room_page14.398b740c.png";